<template>
  <div class="login">
    <HeaderTop :activeIndex="activeIndex" :is_login="is_login"></HeaderTop>
    <div class="login-bannerbox">
      <el-steps :space="200" :active="active" finish-status="success" style="display: flex; justify-content: center; margin-bottom: 30px;" align-center>
        <el-step title="基本信息"></el-step>
        <el-step title="前置学历" v-if="form.isQzxl"></el-step>
        <el-step title="报考信息"></el-step>
        <el-step title="缴费" v-if="form.isBmjf"></el-step>
      </el-steps>
      <el-form :model="form" :rules="dataRules" ref="dataFormRef" v-loading="loading" label-width="150px">
        <template v-if="active == 0">
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="证件类型" prop="idType">
                <el-select v-model="form.idType" placeholder="请选择" clearable>
                  <el-option :label="item.label" :value="+item.value" v-for="(item,index) in id_type" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="证件号" prop="idCardNumber">
                <el-input v-model="form.idCardNumber" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="性别" prop="gender">
                <el-radio-group v-model="form.gender" class="ml-4">
                  <el-radio :label="item.value" size="large" v-for="(item,index) in gender" :key="index">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="民族" prop="nation">
                <el-select v-model="form.nation" placeholder="请选择" clearable>
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in nation" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="政治面貌" prop="politicStatus">
                <el-select v-model="form.politicStatus" placeholder="请选择" clearable>
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in politi_type" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="户籍类型" prop="registerType">
                <el-select v-model="form.registerType" placeholder="请选择" clearable>
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in register_type" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="籍贯" prop="nativePlaceArr">
                <el-cascader class="w100" v-model="form.nativePlaceArr" :options="nativePlaceOptions" :props="{ label: 'text' }" @change="nativePlaceChange($event)" clearable filterable></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="职业" prop="job">
                <el-select v-model="form.job" placeholder="请选择" clearable>
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in profession" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="工作单位" prop="workUnit">
                <el-input v-model="form.workUnit" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="现居住地" prop="contactAddress">
                <el-input v-model="form.contactAddress" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="邮编" prop="postalCode">
                <el-input v-model="form.postalCode" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 身份证上传 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="身份证人像面" prop="sfzAUrl">
                <UploadInfoImage  v-model="form.sfzAUrl" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="身份证国徽面" prop="sfzBUrl">
                <UploadInfoImage  v-model="form.sfzBUrl" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="准考证照片" prop="photo">
                <UploadInfoImage  v-model="form.photo" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <template v-if="active == 1 && form.isQzxl">
          <!-- 第五行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="前置学历" prop="education">
                <el-select v-model="form.education" placeholder="请选择" clearable>
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in education" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="是否毕业" prop="isGraduate">
                <el-radio-group v-model="form.isGraduate" class="ml-4">
                  <el-radio :label="0" size="large">未毕业</el-radio>
                  <el-radio :label="1" size="large">已毕业</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 已毕业显示 -->
          <div v-if="form.isGraduate == 1">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="毕业（在读）专业" prop="specialty">
                  <el-input v-model="form.specialty" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="毕业院校或在读院校" prop="schoolName">
                  <el-input v-model="form.schoolName" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="毕业时间" prop="graduationDate">
                  <el-date-picker v-model="form.graduationDate" type="date" placeholder="选择日期时间" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="毕业证照片" prop="diplomaUrl">
                  <UploadInfoImage  v-model="form.diplomaUrl" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="学历验证报告" prop="certificationReportUrl">
                  <UploadInfoImage  v-model="form.certificationReportUrl" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </template>

        <template v-if="(active == 1 && !form.isQzxl) || (active == 2 && form.isQzxl)">
          <!-- 准考证及院校信息 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="主考院校" prop="">
                {{ form.schCode + '-' + form.schName}}
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="助学点" prop="helpId">
                {{ form.helpCode + '-' + form.helpName }}
              </el-form-item>
            </el-col>
            
            <el-col :span="8">
              <el-form-item label="专业层次" prop="eduLevel">
                <el-select v-model="form.eduLevel" placeholder="请选择" clearable @change="handleGetspecialty">
                  <el-option :label="item.label" :value="item.value" v-for="(item,index) in eduleveles" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            

            <el-col :span="8">
              <el-form-item label="专业" prop="specialtyId">
                <el-select v-model="form.specialtyId" placeholder="请选择" clearable>
                  <el-option :label="`${item.code}-${item.name}`" :value="item.id" v-for="(item,index) in specialtySelect" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <!-- 空列占位，可选 -->
            </el-col>
          </el-row>
        </template>
     
        <template v-if="form.isBmjf && ((active == 2 && !form.isQzxl) || (active == 3 && form.isQzxl))">
          <div class="content">
            <div v-if="list.length == 0" style="text-align: center;">暂无订单</div>
            <div class="li" v-for="(item,index) in list" :key="index">
              <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
                <div v-if="item.orderNo" class="descLi d-flex d-flex-middle">
                  <p class="color9">订单号：</p>
                  <p class="color3">{{ item.orderNo }}</p>
                </div>
              </div>
              <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
                <div class="descLi d-flex d-flex-middle">
                  <p class="color9">费用类型：</p>
                  <p class="color3">第{{ item.yearTime }}学年助学培训费</p>
                </div>
              </div>
              <div class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
                <div class="descLi d-flex d-flex-middle">
                  <p class="color9">金额：</p>
                  <p class="color3" style="color: red; font-weight: bold;">{{ item.money }}</p>
                </div>
              </div>
              <div v-if="item.refundStatus" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
                <div class="descLi d-flex d-flex-middle">
                  <p class="color9">审核状态：</p>
                  <p class="color3">{{ item.refundStatus == 1 ? '退费成功' : '退费失败' }}</p>
                </div>
              </div>
              <div v-if="item.opinion" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
                <div class="descLi d-flex d-flex-middle">
                  <p class="color9">审核意见：</p>
                  <p class="color3">{{ item.opinion }}</p>
                </div>
              </div>
              <div v-if="item.filePath" class="descBox d-flex d-flex-middle" style="margin-bottom: 10px;">
                <div class="descLi d-flex d-flex-middle">
                  <p class="color9">审核附件：</p>
                  <p class="color3"><img :src="item.filePath" style="width: 80px; height: 80px;" alt=""></p>
                </div>
              </div>
              <div class="btns">
                <el-button size="mini" v-if="item.status == 'WZF'" class="my-btn" type="primary" @click="handlePay(item.orderId ,item.yearTime)">支付</el-button>
              </div>
            </div>
          </div>
        </template>

      </el-form>

      <div v-if="!(form.isBmjf && ((active == 2 && !form.isQzxl) || (active == 3 && form.isQzxl)))" style="display: flex; justify-content: center;">
        <el-button type="default" style="margin-top: 12px;" @click="prev" :disabled="active === 0">上一步</el-button>
        <el-button v-if="(this.form.isQzxl && this.active == 2 )|| (!this.form.isQzxl && this.active == 1 )" type="default" style="margin-top: 12px;" @click="next">提交</el-button>
        <el-button v-else type="default" style="margin-top: 12px;" @click="next" :disabled="active === lastStep">下一步</el-button>
      </div>
    </div>

    <Footer></Footer>

    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogVisible" title="扫码缴费" @close="cancelTimer">
      <div>
        <div>
          <table class="table table-bordered">
            <tbody>
            <tr>
              <th>订单编号：</th>
              <td colspan="2"><strong>{{ orderDetail.orderNo }}</strong></td>
            </tr>
            <tr>
              <th>订单金额：</th>
              <td colspan="2" style="color:red;">￥{{ orderDetail.cost }}元</td>
            </tr>
            <tr>
              <th>费用描述：</th>
              <td colspan="2">第{{ orderDetail.yearTime }}学年助学培训费</td>
            </tr>
            <tr>
              <th>创建时间：</th>
              <td>{{ orderDetail.createTime }}</td>
            </tr>
            </tbody>
          </table>
          <!-- 显示支付操作 -->
          <div class="row">
            <div class="col-sm-12">
              <div class="alert alert-success" role="alert">
                <div style="font-size:16px"><strong>请选择以下2种支付方式进行扫码支付，在提示您支付成功之前，请勿关闭当前窗口</strong></div>
                <div style="font-size:16px"><strong><em>（注意：请勿重复支付）</em></strong></div>
              </div>
            </div>
            <div class="col-xs-6 pay-method-box">
              <a href="javascript:void(0)" @click="wxpay" class="pay-method">
                <img :src="wxQrcode || 'https://jxjy-att.whxunw.com/sczk_att/upload/20250616/7d134a8cc2224b04a076b7efc822b9bb.png'" alt="微信支付" :style="wxStyle">
              </a>
            </div>
            <div class="col-xs-6 pay-method-box">
              <a href="javascript:void(0)" class="pay-method" @click="alipay">
                <img src="../assets/alipay.png" alt="支付宝支付" style="height: 60px; width: 100%; display: block;margin-top:80px">
              </a>
            </div>
          </div>
        </div>
        <!-- 隐藏支付宝跳转表单 -->
        <div style="display:none" id="ali_submit_div">

        </div>
      </div>
      <div class="dialog-footer" slot="footer">
        <el-button @click="cancelTimer" size="mini" type="primary">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import { mapState } from "vuex"

export default {
  name: 'Login',
  components: {
    vueQr,
    HeaderTop,
    Footer,
    UploadInfoImage: () => import("@/components/UploadInfoImage.vue"),
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      verificationImageUrl: null,
      intervalTime: null,
      smsSecond: 0,
      form: {
        name: '丁真',
        idCardNumber: '421083199108194911',
        phone: '18371513155',
        code: '',
      },
      user: undefined,
      activeIndex: 'Login',
      is_login: true, // 是否首页
      type: 0,
      verificationImageUrl: '',
      studentList: [],
      chooseDialogVisible: false,
      selectedStudentId: null,

      active: 0,
      form: {
        id: '',
        // 手动
        name: '',
        photo: '',
        idType: '',
        idCardNumber: '',
        gender: '',
        nation: '',
        politicStatus: '',
        registerType: '',
        nativePlace: '',
        nativePlaceArr: [],
        job: '',
        workUnit: '',
        phone: '',
        postalCode: '',
        contactAddress: '',
        education: '',
        isGraduate: '',
        specialty: '',
        schoolName: '',
        sfzAUrl: '',
        sfzBUrl: '',
        schoolId: '',
        schCode: '',
        schName: '',
        helpId: '',
        helpCode: '',
        helpName: '',
        specialtyId: '',
        eduLevel: '',
        registerProvince: '',
        registerCity: '',
        updateRemark: '',
        certiNo: '',
        status: '',
        graduationDate: '',
        diplomaUrl: '',
        certificationReportUrl: '',
        // 读卡
        textName: '',
        sfzUrl: '',
        textIdNum: '',
        textSex: '',
        textNation: '',
        sfzAddress: '',
      },
      dataRules: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        photo: [{ required: true, message: '准考证照片不能为空', trigger: 'change' }],
        idType: [{ required: true, message: '证件类型不能为空', trigger: 'change' }],
        idCardNumber: [
          { required: true, message: '证件号不能为空', trigger: 'blur' },
        ],
        sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
        gender: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
        nation: [{ required: true, message: '民族不能为空', trigger: 'change' }],
        politicsStatus: [
          { required: true, message: '政治面貌不能为空', trigger: 'change' },
        ],
        politicStatus: [
          { required: true, message: '政治面貌不能为空', trigger: 'change' },
        ],
        registerType: [
          { required: true, message: '户籍类型不能为空', trigger: 'change' },
        ],
        nativePlaceArr: [{ required: true, message: '籍贯不能为空', trigger: 'change' }],
        job: [{ required: true, message: '职业不能为空', trigger: 'change' }],
        // workUnit: [{ required: true, message: '工作单位不能为空', trigger: 'blur' }],
        phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
        // postalCode: [{ required: true, message: '邮编不能为空', trigger: 'blur' }],
        contactAddress: [
          { required: true, message: '现居住地不能为空', trigger: 'blur' },
        ],
        education: [
          { required: true, message: '前置学历不能为空', trigger: 'change' },
        ],
        isGraduate: [
          { required: true, message: '是否已毕业不能为空', trigger: 'change' },
        ],
        specialty: [
          { required: true, message: '毕业（在读）专业不能为空', trigger: 'blur' },
        ],
        schoolName: [
          { required: true, message: '毕业院校或在读院校不能为空', trigger: 'blur' },
        ],
        graduationDate: [
          { required: true, message: '毕业时间不能为空', trigger: 'change' }
        ],
        sfzAUrl: [
          { required: true, message: '身份证人像面不能为空', trigger: 'change' },
        ],
        sfzBUrl: [
          { required: true, message: '身份证国徽面不能为空', trigger: 'change' },
        ],
        schoolId: [
          { required: true, message: '主考学校不能为空', trigger: 'change' },
        ],
        helpId: [{ required: false, message: '助学点不能为空', trigger: 'change' }],
        specialtyId: [{ required: true, message: '专业不能为空', trigger: 'change' }],
        eduLevel: [
          { required: true, message: '专业层次不能为空', trigger: 'change' },
        ],
        updateRemark: [
          { required: true, message: '修改说明不能为空', trigger: 'blur' },
        ],
        certiNo: [
          { required: true, message: '准考证号不能为空', trigger: 'blur' },
        ],
        // 读卡
        textName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        sfzUrl: [{ required: true, message: '照片不能为空', trigger: 'blur' }],
        textIdNum: [{ required: true, message: '证件号不能为空', trigger: 'blur' }],
        textSex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
        textNation: [{ required: true, message: '民族不能为空', trigger: 'blur' }],
        sfzAddress: [
          { required: true, message: '身份证地址不能为空', trigger: 'blur' },
        ],
      },
      id_type: [],
      gender: [],
      nation: [],
      politi_type: [],
      register_type: [],
      profession: [],
      education: [],
      eduleveles: [],
      specialtySelect: [],

      CITYJSON: '{"110000":[{"value":"110101","text":"东城区","province":"北京市"},{"value":"110102","text":"西城区","province":"北京市"},{"value":"110105","text":"朝阳区","province":"北京市"},{"value":"110106","text":"丰台区","province":"北京市"},{"value":"110107","text":"石景山区","province":"北京市"},{"value":"110108","text":"海淀区","province":"北京市"},{"value":"110109","text":"门头沟区","province":"北京市"},{"value":"110111","text":"房山区","province":"北京市"},{"value":"110112","text":"通州区","province":"北京市"},{"value":"110113","text":"顺义区","province":"北京市"},{"value":"110114","text":"昌平区","province":"北京市"},{"value":"110115","text":"大兴区","province":"北京市"},{"value":"110116","text":"怀柔区","province":"北京市"},{"value":"110117","text":"平谷区","province":"北京市"},{"value":"110118","text":"密云区","province":"北京市"},{"value":"110119","text":"延庆区","province":"北京市"}],"120000":[{"value":"120101","text":"和平区","province":"天津市"},{"value":"120102","text":"河东区","province":"天津市"},{"value":"120103","text":"河西区","province":"天津市"},{"value":"120104","text":"南开区","province":"天津市"},{"value":"120105","text":"河北区","province":"天津市"},{"value":"120106","text":"红桥区","province":"天津市"},{"value":"120110","text":"东丽区","province":"天津市"},{"value":"120111","text":"西青区","province":"天津市"},{"value":"120112","text":"津南区","province":"天津市"},{"value":"120113","text":"北辰区","province":"天津市"},{"value":"120114","text":"武清区","province":"天津市"},{"value":"120115","text":"宝坻区","province":"天津市"},{"value":"120116","text":"滨海新区","province":"天津市"},{"value":"120117","text":"宁河区","province":"天津市"},{"value":"120118","text":"静海区","province":"天津市"},{"value":"120119","text":"蓟州区","province":"天津市"}],"130000":[{"value":"130100","text":"石家庄市","province":"河北省"},{"value":"130200","text":"唐山市","province":"河北省"},{"value":"130300","text":"秦皇岛市","province":"河北省"},{"value":"130400","text":"邯郸市","province":"河北省"},{"value":"130500","text":"邢台市","province":"河北省"},{"value":"130600","text":"保定市","province":"河北省"},{"value":"130700","text":"张家口市","province":"河北省"},{"value":"130800","text":"承德市","province":"河北省"},{"value":"130900","text":"沧州市","province":"河北省"},{"value":"131000","text":"廊坊市","province":"河北省"},{"value":"131100","text":"衡水市","province":"河北省"},{"value":"139000","text":"省直辖县级行政区划","province":"河北省"}],"140000":[{"value":"140100","text":"太原市","province":"山西省"},{"value":"140200","text":"大同市","province":"山西省"},{"value":"140300","text":"阳泉市","province":"山西省"},{"value":"140400","text":"长治市","province":"山西省"},{"value":"140500","text":"晋城市","province":"山西省"},{"value":"140600","text":"朔州市","province":"山西省"},{"value":"140700","text":"晋中市","province":"山西省"},{"value":"140800","text":"运城市","province":"山西省"},{"value":"140900","text":"忻州市","province":"山西省"},{"value":"141000","text":"临汾市","province":"山西省"},{"value":"141100","text":"吕梁市","province":"山西省"}],"150000":[{"value":"150100","text":"呼和浩特市","province":"内蒙古自治区"},{"value":"150200","text":"包头市","province":"内蒙古自治区"},{"value":"150300","text":"乌海市","province":"内蒙古自治区"},{"value":"150400","text":"赤峰市","province":"内蒙古自治区"},{"value":"150500","text":"通辽市","province":"内蒙古自治区"},{"value":"150600","text":"鄂尔多斯市","province":"内蒙古自治区"},{"value":"150700","text":"呼伦贝尔市","province":"内蒙古自治区"},{"value":"150800","text":"巴彦淖尔市","province":"内蒙古自治区"},{"value":"150900","text":"乌兰察布市","province":"内蒙古自治区"},{"value":"152200","text":"兴安盟","province":"内蒙古自治区"},{"value":"152500","text":"锡林郭勒盟","province":"内蒙古自治区"},{"value":"152900","text":"阿拉善盟","province":"内蒙古自治区"}],"210000":[{"value":"210100","text":"沈阳市","province":"辽宁省"},{"value":"210200","text":"大连市","province":"辽宁省"},{"value":"210300","text":"鞍山市","province":"辽宁省"},{"value":"210400","text":"抚顺市","province":"辽宁省"},{"value":"210500","text":"本溪市","province":"辽宁省"},{"value":"210600","text":"丹东市","province":"辽宁省"},{"value":"210700","text":"锦州市","province":"辽宁省"},{"value":"210800","text":"营口市","province":"辽宁省"},{"value":"210900","text":"阜新市","province":"辽宁省"},{"value":"211000","text":"辽阳市","province":"辽宁省"},{"value":"211100","text":"盘锦市","province":"辽宁省"},{"value":"211200","text":"铁岭市","province":"辽宁省"},{"value":"211300","text":"朝阳市","province":"辽宁省"},{"value":"211400","text":"葫芦岛市","province":"辽宁省"}],"220000":[{"value":"220100","text":"长春市","province":"吉林省"},{"value":"220200","text":"吉林市","province":"吉林省"},{"value":"220300","text":"四平市","province":"吉林省"},{"value":"220400","text":"辽源市","province":"吉林省"},{"value":"220500","text":"通化市","province":"吉林省"},{"value":"220600","text":"白山市","province":"吉林省"},{"value":"220700","text":"松原市","province":"吉林省"},{"value":"220800","text":"白城市","province":"吉林省"},{"value":"222400","text":"延边朝鲜族自治州","province":"吉林省"}],"230000":[{"value":"230100","text":"哈尔滨市","province":"黑龙江省"},{"value":"230200","text":"齐齐哈尔市","province":"黑龙江省"},{"value":"230300","text":"鸡西市","province":"黑龙江省"},{"value":"230400","text":"鹤岗市","province":"黑龙江省"},{"value":"230500","text":"双鸭山市","province":"黑龙江省"},{"value":"230600","text":"大庆市","province":"黑龙江省"},{"value":"230700","text":"伊春市","province":"黑龙江省"},{"value":"230800","text":"佳木斯市","province":"黑龙江省"},{"value":"230900","text":"七台河市","province":"黑龙江省"},{"value":"231000","text":"牡丹江市","province":"黑龙江省"},{"value":"231100","text":"黑河市","province":"黑龙江省"},{"value":"231200","text":"绥化市","province":"黑龙江省"},{"value":"232700","text":"大兴安岭地区","province":"黑龙江省"}],"310000":[{"value":"310101","text":"黄浦区","province":"上海市"},{"value":"310104","text":"徐汇区","province":"上海市"},{"value":"310105","text":"长宁区","province":"上海市"},{"value":"310106","text":"静安区","province":"上海市"},{"value":"310107","text":"普陀区","province":"上海市"},{"value":"310109","text":"虹口区","province":"上海市"},{"value":"310110","text":"杨浦区","province":"上海市"},{"value":"310112","text":"闵行区","province":"上海市"},{"value":"310113","text":"宝山区","province":"上海市"},{"value":"310114","text":"嘉定区","province":"上海市"},{"value":"310115","text":"浦东新区","province":"上海市"},{"value":"310116","text":"金山区","province":"上海市"},{"value":"310117","text":"松江区","province":"上海市"},{"value":"310118","text":"青浦区","province":"上海市"},{"value":"310120","text":"奉贤区","province":"上海市"},{"value":"310151","text":"崇明区","province":"上海市"}],"320000":[{"value":"320100","text":"南京市","province":"江苏省"},{"value":"320200","text":"无锡市","province":"江苏省"},{"value":"320300","text":"徐州市","province":"江苏省"},{"value":"320400","text":"常州市","province":"江苏省"},{"value":"320500","text":"苏州市","province":"江苏省"},{"value":"320600","text":"南通市","province":"江苏省"},{"value":"320700","text":"连云港市","province":"江苏省"},{"value":"320800","text":"淮安市","province":"江苏省"},{"value":"320900","text":"盐城市","province":"江苏省"},{"value":"321000","text":"扬州市","province":"江苏省"},{"value":"321100","text":"镇江市","province":"江苏省"},{"value":"321200","text":"泰州市","province":"江苏省"},{"value":"321300","text":"宿迁市","province":"江苏省"}],"330000":[{"value":"330100","text":"杭州市","province":"浙江省"},{"value":"330200","text":"宁波市","province":"浙江省"},{"value":"330300","text":"温州市","province":"浙江省"},{"value":"330400","text":"嘉兴市","province":"浙江省"},{"value":"330500","text":"湖州市","province":"浙江省"},{"value":"330600","text":"绍兴市","province":"浙江省"},{"value":"330700","text":"金华市","province":"浙江省"},{"value":"330800","text":"衢州市","province":"浙江省"},{"value":"330900","text":"舟山市","province":"浙江省"},{"value":"331000","text":"台州市","province":"浙江省"},{"value":"331100","text":"丽水市","province":"浙江省"}],"340000":[{"value":"340100","text":"合肥市","province":"安徽省"},{"value":"340200","text":"芜湖市","province":"安徽省"},{"value":"340300","text":"蚌埠市","province":"安徽省"},{"value":"340400","text":"淮南市","province":"安徽省"},{"value":"340500","text":"马鞍山市","province":"安徽省"},{"value":"340600","text":"淮北市","province":"安徽省"},{"value":"340700","text":"铜陵市","province":"安徽省"},{"value":"340800","text":"安庆市","province":"安徽省"},{"value":"341000","text":"黄山市","province":"安徽省"},{"value":"341100","text":"滁州市","province":"安徽省"},{"value":"341200","text":"阜阳市","province":"安徽省"},{"value":"341300","text":"宿州市","province":"安徽省"},{"value":"341500","text":"六安市","province":"安徽省"},{"value":"341600","text":"亳州市","province":"安徽省"},{"value":"341700","text":"池州市","province":"安徽省"},{"value":"341800","text":"宣城市","province":"安徽省"}],"350000":[{"value":"350100","text":"福州市","province":"福建省"},{"value":"350200","text":"厦门市","province":"福建省"},{"value":"350300","text":"莆田市","province":"福建省"},{"value":"350400","text":"三明市","province":"福建省"},{"value":"350500","text":"泉州市","province":"福建省"},{"value":"350600","text":"漳州市","province":"福建省"},{"value":"350700","text":"南平市","province":"福建省"},{"value":"350800","text":"龙岩市","province":"福建省"},{"value":"350900","text":"宁德市","province":"福建省"}],"360000":[{"value":"360100","text":"南昌市","province":"江西省"},{"value":"360200","text":"景德镇市","province":"江西省"},{"value":"360300","text":"萍乡市","province":"江西省"},{"value":"360400","text":"九江市","province":"江西省"},{"value":"360500","text":"新余市","province":"江西省"},{"value":"360600","text":"鹰潭市","province":"江西省"},{"value":"360700","text":"赣州市","province":"江西省"},{"value":"360800","text":"吉安市","province":"江西省"},{"value":"360900","text":"宜春市","province":"江西省"},{"value":"361000","text":"抚州市","province":"江西省"},{"value":"361100","text":"上饶市","province":"江西省"}],"370000":[{"value":"370100","text":"济南市","province":"山东省"},{"value":"370200","text":"青岛市","province":"山东省"},{"value":"370300","text":"淄博市","province":"山东省"},{"value":"370400","text":"枣庄市","province":"山东省"},{"value":"370500","text":"东营市","province":"山东省"},{"value":"370600","text":"烟台市","province":"山东省"},{"value":"370700","text":"潍坊市","province":"山东省"},{"value":"370800","text":"济宁市","province":"山东省"},{"value":"370900","text":"泰安市","province":"山东省"},{"value":"371000","text":"威海市","province":"山东省"},{"value":"371100","text":"日照市","province":"山东省"},{"value":"371200","text":"莱芜市","province":"山东省"},{"value":"371300","text":"临沂市","province":"山东省"},{"value":"371400","text":"德州市","province":"山东省"},{"value":"371500","text":"聊城市","province":"山东省"},{"value":"371600","text":"滨州市","province":"山东省"},{"value":"371700","text":"菏泽市","province":"山东省"}],"410000":[{"value":"410100","text":"郑州市","province":"河南省"},{"value":"410200","text":"开封市","province":"河南省"},{"value":"410300","text":"洛阳市","province":"河南省"},{"value":"410400","text":"平顶山市","province":"河南省"},{"value":"410500","text":"安阳市","province":"河南省"},{"value":"410600","text":"鹤壁市","province":"河南省"},{"value":"410700","text":"新乡市","province":"河南省"},{"value":"410800","text":"焦作市","province":"河南省"},{"value":"410900","text":"濮阳市","province":"河南省"},{"value":"411000","text":"许昌市","province":"河南省"},{"value":"411100","text":"漯河市","province":"河南省"},{"value":"411200","text":"三门峡市","province":"河南省"},{"value":"411300","text":"南阳市","province":"河南省"},{"value":"411400","text":"商丘市","province":"河南省"},{"value":"411500","text":"信阳市","province":"河南省"},{"value":"411600","text":"周口市","province":"河南省"},{"value":"411700","text":"驻马店市","province":"河南省"},{"value":"419000","text":"省直辖县级行政区划","province":"河南省"}],"420000":[{"value":"420100","text":"武汉市","province":"湖北省"},{"value":"420200","text":"黄石市","province":"湖北省"},{"value":"420300","text":"十堰市","province":"湖北省"},{"value":"420500","text":"宜昌市","province":"湖北省"},{"value":"420600","text":"襄阳市","province":"湖北省"},{"value":"420700","text":"鄂州市","province":"湖北省"},{"value":"420800","text":"荆门市","province":"湖北省"},{"value":"420900","text":"孝感市","province":"湖北省"},{"value":"421000","text":"荆州市","province":"湖北省"},{"value":"421100","text":"黄冈市","province":"湖北省"},{"value":"421200","text":"咸宁市","province":"湖北省"},{"value":"421300","text":"随州市","province":"湖北省"},{"value":"422800","text":"恩施土家族苗族自治州","province":"湖北省"},{"value":"429000","text":"省直辖县级行政区划","province":"湖北省"}],"430000":[{"value":"430100","text":"长沙市","province":"湖南省"},{"value":"430200","text":"株洲市","province":"湖南省"},{"value":"430300","text":"湘潭市","province":"湖南省"},{"value":"430400","text":"衡阳市","province":"湖南省"},{"value":"430500","text":"邵阳市","province":"湖南省"},{"value":"430600","text":"岳阳市","province":"湖南省"},{"value":"430700","text":"常德市","province":"湖南省"},{"value":"430800","text":"张家界市","province":"湖南省"},{"value":"430900","text":"益阳市","province":"湖南省"},{"value":"431000","text":"郴州市","province":"湖南省"},{"value":"431100","text":"永州市","province":"湖南省"},{"value":"431200","text":"怀化市","province":"湖南省"},{"value":"431300","text":"娄底市","province":"湖南省"},{"value":"433100","text":"湘西土家族苗族自治州","province":"湖南省"}],"440000":[{"value":"440100","text":"广州市","province":"广东省"},{"value":"440200","text":"韶关市","province":"广东省"},{"value":"440300","text":"深圳市","province":"广东省"},{"value":"440400","text":"珠海市","province":"广东省"},{"value":"440500","text":"汕头市","province":"广东省"},{"value":"440600","text":"佛山市","province":"广东省"},{"value":"440700","text":"江门市","province":"广东省"},{"value":"440800","text":"湛江市","province":"广东省"},{"value":"440900","text":"茂名市","province":"广东省"},{"value":"441200","text":"肇庆市","province":"广东省"},{"value":"441300","text":"惠州市","province":"广东省"},{"value":"441400","text":"梅州市","province":"广东省"},{"value":"441500","text":"汕尾市","province":"广东省"},{"value":"441600","text":"河源市","province":"广东省"},{"value":"441700","text":"阳江市","province":"广东省"},{"value":"441800","text":"清远市","province":"广东省"},{"value":"441900","text":"东莞市","province":"广东省"},{"value":"442000","text":"中山市","province":"广东省"},{"value":"445100","text":"潮州市","province":"广东省"},{"value":"445200","text":"揭阳市","province":"广东省"},{"value":"445300","text":"云浮市","province":"广东省"}],"450000":[{"value":"450100","text":"南宁市","province":"广西壮族自治区"},{"value":"450200","text":"柳州市","province":"广西壮族自治区"},{"value":"450300","text":"桂林市","province":"广西壮族自治区"},{"value":"450400","text":"梧州市","province":"广西壮族自治区"},{"value":"450500","text":"北海市","province":"广西壮族自治区"},{"value":"450600","text":"防城港市","province":"广西壮族自治区"},{"value":"450700","text":"钦州市","province":"广西壮族自治区"},{"value":"450800","text":"贵港市","province":"广西壮族自治区"},{"value":"450900","text":"玉林市","province":"广西壮族自治区"},{"value":"451000","text":"百色市","province":"广西壮族自治区"},{"value":"451100","text":"贺州市","province":"广西壮族自治区"},{"value":"451200","text":"河池市","province":"广西壮族自治区"},{"value":"451300","text":"来宾市","province":"广西壮族自治区"},{"value":"451400","text":"崇左市","province":"广西壮族自治区"}],"460000":[{"value":"460100","text":"海口市","province":"海南省"},{"value":"460200","text":"三亚市","province":"海南省"},{"value":"460300","text":"三沙市","province":"海南省"},{"value":"460400","text":"儋州市","province":"海南省"},{"value":"469000","text":"省直辖县级行政区划","province":"海南省"}],"500000":[{"value":"500101","text":"万州区","province":"重庆市"},{"value":"500102","text":"涪陵区","province":"重庆市"},{"value":"500103","text":"渝中区","province":"重庆市"},{"value":"500104","text":"大渡口区","province":"重庆市"},{"value":"500105","text":"江北区","province":"重庆市"},{"value":"500106","text":"沙坪坝区","province":"重庆市"},{"value":"500107","text":"九龙坡区","province":"重庆市"},{"value":"500108","text":"南岸区","province":"重庆市"},{"value":"500109","text":"北碚区","province":"重庆市"},{"value":"500110","text":"綦江区","province":"重庆市"},{"value":"500111","text":"大足区","province":"重庆市"},{"value":"500112","text":"渝北区","province":"重庆市"},{"value":"500113","text":"巴南区","province":"重庆市"},{"value":"500114","text":"黔江区","province":"重庆市"},{"value":"500115","text":"长寿区","province":"重庆市"},{"value":"500116","text":"江津区","province":"重庆市"},{"value":"500117","text":"合川区","province":"重庆市"},{"value":"500118","text":"永川区","province":"重庆市"},{"value":"500119","text":"南川区","province":"重庆市"},{"value":"500120","text":"璧山区","province":"重庆市"},{"value":"500151","text":"铜梁区","province":"重庆市"},{"value":"500152","text":"潼南区","province":"重庆市"},{"value":"500153","text":"荣昌区","province":"重庆市"},{"value":"500154","text":"开州区","province":"重庆市"}],"510000":[{"value":"510100","text":"成都市","province":"四川省"},{"value":"510300","text":"自贡市","province":"四川省"},{"value":"510400","text":"攀枝花市","province":"四川省"},{"value":"510500","text":"泸州市","province":"四川省"},{"value":"510600","text":"德阳市","province":"四川省"},{"value":"510700","text":"绵阳市","province":"四川省"},{"value":"510800","text":"广元市","province":"四川省"},{"value":"510900","text":"遂宁市","province":"四川省"},{"value":"511000","text":"内江市","province":"四川省"},{"value":"511100","text":"乐山市","province":"四川省"},{"value":"511300","text":"南充市","province":"四川省"},{"value":"511400","text":"眉山市","province":"四川省"},{"value":"511500","text":"宜宾市","province":"四川省"},{"value":"511600","text":"广安市","province":"四川省"},{"value":"511700","text":"达州市","province":"四川省"},{"value":"511800","text":"雅安市","province":"四川省"},{"value":"511900","text":"巴中市","province":"四川省"},{"value":"512000","text":"资阳市","province":"四川省"},{"value":"513200","text":"阿坝藏族羌族自治州","province":"四川省"},{"value":"513300","text":"甘孜藏族自治州","province":"四川省"},{"value":"513400","text":"凉山彝族自治州","province":"四川省"}],"520000":[{"value":"520100","text":"贵阳市","province":"贵州省"},{"value":"520200","text":"六盘水市","province":"贵州省"},{"value":"520300","text":"遵义市","province":"贵州省"},{"value":"520400","text":"安顺市","province":"贵州省"},{"value":"520500","text":"毕节市","province":"贵州省"},{"value":"520600","text":"铜仁市","province":"贵州省"},{"value":"522300","text":"黔西南布依族苗族自治州","province":"贵州省"},{"value":"522600","text":"黔东南苗族侗族自治州","province":"贵州省"},{"value":"522700","text":"黔南布依族苗族自治州","province":"贵州省"}],"530000":[{"value":"530100","text":"昆明市","province":"云南省"},{"value":"530300","text":"曲靖市","province":"云南省"},{"value":"530400","text":"玉溪市","province":"云南省"},{"value":"530500","text":"保山市","province":"云南省"},{"value":"530600","text":"昭通市","province":"云南省"},{"value":"530700","text":"丽江市","province":"云南省"},{"value":"530800","text":"普洱市","province":"云南省"},{"value":"530900","text":"临沧市","province":"云南省"},{"value":"532300","text":"楚雄彝族自治州","province":"云南省"},{"value":"532500","text":"红河哈尼族彝族自治州","province":"云南省"},{"value":"532600","text":"文山壮族苗族自治州","province":"云南省"},{"value":"532800","text":"西双版纳傣族自治州","province":"云南省"},{"value":"532900","text":"大理白族自治州","province":"云南省"},{"value":"533100","text":"德宏傣族景颇族自治州","province":"云南省"},{"value":"533300","text":"怒江傈僳族自治州","province":"云南省"},{"value":"533400","text":"迪庆藏族自治州","province":"云南省"}],"540000":[{"value":"540100","text":"拉萨市","province":"西藏自治区"},{"value":"540200","text":"日喀则市","province":"西藏自治区"},{"value":"540300","text":"昌都市","province":"西藏自治区"},{"value":"540400","text":"林芝市","province":"西藏自治区"},{"value":"540500","text":"山南市","province":"西藏自治区"},{"value":"542400","text":"那曲地区","province":"西藏自治区"},{"value":"542500","text":"阿里地区","province":"西藏自治区"}],"610000":[{"value":"610100","text":"西安市","province":"陕西省"},{"value":"610200","text":"铜川市","province":"陕西省"},{"value":"610300","text":"宝鸡市","province":"陕西省"},{"value":"610400","text":"咸阳市","province":"陕西省"},{"value":"610500","text":"渭南市","province":"陕西省"},{"value":"610600","text":"延安市","province":"陕西省"},{"value":"610700","text":"汉中市","province":"陕西省"},{"value":"610800","text":"榆林市","province":"陕西省"},{"value":"610900","text":"安康市","province":"陕西省"},{"value":"611000","text":"商洛市","province":"陕西省"}],"620000":[{"value":"620100","text":"兰州市","province":"甘肃省"},{"value":"620200","text":"嘉峪关市","province":"甘肃省"},{"value":"620300","text":"金昌市","province":"甘肃省"},{"value":"620400","text":"白银市","province":"甘肃省"},{"value":"620500","text":"天水市","province":"甘肃省"},{"value":"620600","text":"武威市","province":"甘肃省"},{"value":"620700","text":"张掖市","province":"甘肃省"},{"value":"620800","text":"平凉市","province":"甘肃省"},{"value":"620900","text":"酒泉市","province":"甘肃省"},{"value":"621000","text":"庆阳市","province":"甘肃省"},{"value":"621100","text":"定西市","province":"甘肃省"},{"value":"621200","text":"陇南市","province":"甘肃省"},{"value":"622900","text":"临夏回族自治州","province":"甘肃省"},{"value":"623000","text":"甘南藏族自治州","province":"甘肃省"}],"630000":[{"value":"630100","text":"西宁市","province":"青海省"},{"value":"630200","text":"海东市","province":"青海省"},{"value":"632200","text":"海北藏族自治州","province":"青海省"},{"value":"632300","text":"黄南藏族自治州","province":"青海省"},{"value":"632500","text":"海南藏族自治州","province":"青海省"},{"value":"632600","text":"果洛藏族自治州","province":"青海省"},{"value":"632700","text":"玉树藏族自治州","province":"青海省"},{"value":"632800","text":"海西蒙古族藏族自治州","province":"青海省"}],"640000":[{"value":"640100","text":"银川市","province":"宁夏回族自治区"},{"value":"640200","text":"石嘴山市","province":"宁夏回族自治区"},{"value":"640300","text":"吴忠市","province":"宁夏回族自治区"},{"value":"640400","text":"固原市","province":"宁夏回族自治区"},{"value":"640500","text":"中卫市","province":"宁夏回族自治区"}],"650000":[{"value":"650100","text":"乌鲁木齐市","province":"新疆维吾尔自治区"},{"value":"650200","text":"克拉玛依市","province":"新疆维吾尔自治区"},{"value":"650400","text":"吐鲁番市","province":"新疆维吾尔自治区"},{"value":"650500","text":"哈密市","province":"新疆维吾尔自治区"},{"value":"652300","text":"昌吉回族自治州","province":"新疆维吾尔自治区"},{"value":"652700","text":"博尔塔拉蒙古自治州","province":"新疆维吾尔自治区"},{"value":"652800","text":"巴音郭楞蒙古自治州","province":"新疆维吾尔自治区"},{"value":"652900","text":"阿克苏地区","province":"新疆维吾尔自治区"},{"value":"653000","text":"克孜勒苏柯尔克孜自治州","province":"新疆维吾尔自治区"},{"value":"653100","text":"喀什地区","province":"新疆维吾尔自治区"},{"value":"653200","text":"和田地区","province":"新疆维吾尔自治区"},{"value":"654000","text":"伊犁哈萨克自治州","province":"新疆维吾尔自治区"},{"value":"654200","text":"塔城地区","province":"新疆维吾尔自治区"},{"value":"654300","text":"阿勒泰地区","province":"新疆维吾尔自治区"},{"value":"659000","text":"自治区直辖县级行政区划","province":"新疆维吾尔自治区"}],"710000":[{"value":"710100","text":"台北市","province":"台湾省"},{"value":"710200","text":"高雄市","province":"台湾省"},{"value":"710300","text":"台南市","province":"台湾省"},{"value":"710400","text":"台中市","province":"台湾省"},{"value":"710500","text":"金门县","province":"台湾省"},{"value":"710600","text":"南投县","province":"台湾省"},{"value":"710700","text":"基隆市","province":"台湾省"},{"value":"710800","text":"新竹市","province":"台湾省"},{"value":"710900","text":"嘉义市","province":"台湾省"},{"value":"711100","text":"新北市","province":"台湾省"},{"value":"711200","text":"宜兰县","province":"台湾省"},{"value":"711300","text":"新竹县","province":"台湾省"},{"value":"711400","text":"桃园县","province":"台湾省"},{"value":"711500","text":"苗栗县","province":"台湾省"},{"value":"711700","text":"彰化县","province":"台湾省"},{"value":"711900","text":"嘉义县","province":"台湾省"},{"value":"712100","text":"云林县","province":"台湾省"},{"value":"712400","text":"屏东县","province":"台湾省"},{"value":"712500","text":"台东县","province":"台湾省"},{"value":"712600","text":"花莲县","province":"台湾省"},{"value":"712700","text":"澎湖县","province":"台湾省"}],"810000":[{"value":"810100","text":"香港岛","province":"香港特别行政区"},{"value":"810200","text":"九龙","province":"香港特别行政区"},{"value":"810300","text":"新界","province":"香港特别行政区"}],"820000":[{"value":"820100","text":"澳门半岛","province":"澳门特别行政区"},{"value":"820200","text":"氹仔岛","province":"澳门特别行政区"},{"value":"820300","text":"路环岛","province":"澳门特别行政区"}]}',
      PROJSON: '[{"text":"北京市","value":"110000"},{"text":"天津市","value":"120000"},{"text":"河北省","value":"130000"},{"text":"山西省","value":"140000"},{"text":"内蒙古自治区","value":"150000"},{"text":"辽宁省","value":"210000"},{"text":"吉林省","value":"220000"},{"text":"黑龙江省","value":"230000"},{"text":"上海市","value":"310000"},{"text":"江苏省","value":"320000"},{"text":"浙江省","value":"330000"},{"text":"安徽省","value":"340000"},{"text":"福建省","value":"350000"},{"text":"江西省","value":"360000"},{"text":"山东省","value":"370000"},{"text":"河南省","value":"410000"},{"text":"湖北省","value":"420000"},{"text":"湖南省","value":"430000"},{"text":"广东省","value":"440000"},{"text":"广西壮族自治区","value":"450000"},{"text":"海南省","value":"460000"},{"text":"重庆市","value":"500000"},{"text":"四川省","value":"510000"},{"text":"贵州省","value":"520000"},{"text":"云南省","value":"530000"},{"text":"西藏自治区","value":"540000"},{"text":"陕西省","value":"610000"},{"text":"甘肃省","value":"620000"},{"text":"青海省","value":"630000"},{"text":"宁夏回族自治区","value":"640000"},{"text":"新疆维吾尔自治区","value":"650000"}]',
      nativePlaceOptions: [],
      lastStep: 2,

      list: [],
      dialogVisible: false,
      orderDetail: {},
      wxQrcode: '',
      wxStyle: {
        height: '60px',
        width: '100%',
        display: 'block',
        marginTop: '80px'
      },
      timer: null
      };
  },
  computed: {
  },
  created() {
    this.nativePlaceOptions = JSON.parse(this.PROJSON)
    this.nativePlaceOptions.forEach((item) => {
      item.children = JSON.parse(this.CITYJSON)[item.value]
    })
    this.$http.get('/student/register/getStudentInfo', { studentId: this.$route.query.studentId }).then(res => {
      console.log(res);
      if (res.registerProvince) {
        let rObj = {}
        this.nativePlaceOptions.forEach((item) => {
          if (item.value == res.registerProvince) {
            rObj = item.children.find(
              (obj) => obj.value == res.registerCity
            )
          }
        })
        res.nativePlaceArr = [res.registerProvince, res.registerCity]
      }
      // res.isQzxl = 0
      // res.isBmjf = 0
      this.form = res
      this.updateLastStep();

      if (res.isBmjf) {
        this.getOrder()
      }
      this.$http.get('/student/register/getSpecialtys', { 
        schoolId: res.schoolId,
        helpId: res.helpId,
        eduLevel:res.eduLevel,
        ndm:res.ndm,
      })
        .then(spec => {
          this.specialtySelect = spec
        })
    })
    this.$http.post('/student/common/getDictItemByTypes', ["gender","profession","eduleveles","politi_type","nation","id_type","student_status","education","register_type"]).then(res => {
      console.log(res);
      this.id_type = res.id_type
      this.gender = res.gender
      this.register_type = res.register_type
      this.nation = res.nation
      this.politi_type = res.politi_type
      this.profession = res.profession
      this.education = res.education
      this.eduleveles = res.eduleveles
    })
  },
  mounted() {
  },
  destroyed() {
    if (this.intervalTime) {
      clearInterval(this.intervalTime);
    }
  },

  methods: {
    prev() {
      this.active--
    },
    next() {
      this.$refs['dataFormRef'].validate((valid) => {
        if (valid) {
          if ((this.form.isQzxl && this.active == 2 )|| (!this.form.isQzxl && this.active == 1 )) {
            this.$http.post('/student/register/editInfo', this.form).then(res => {
              this.$message.success(`提交成功`)
              if (this.form.isBmjf) {
                this.active++
              }
            })
          } else {
            this.active++
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateLastStep() {
      let steps = 2; // 基本信息 + 报考信息
      if (this.form.isQzxl) {
        steps++; // 如果显示“前置学历”，则增加一个步骤
      }
      if (this.form.isBmjf) {
        steps++; // 如果显示“缴费”，则增加一个步骤
      }
      this.lastStep = steps - 1; // 计算最后一步的索引
    },
    handleGetspecialty(e) {
      console.log(e)
      this.form.specialtyId = ''
      this.specialtySelect = []
      if (e) {
        this.$http.get('/student/register/getSpecialtys', { 
          schoolId: this.form.schoolId,
          helpId: this.form.helpId,
          eduLevel:this.form.eduLevel,
          ndm:this.form.ndm,
        }).then(spec => {
            this.specialtySelect = spec
          })
      }
    },
    // 籍贯改变
    nativePlaceChange(province) {
      if (province && province.length == 2) {
        this.form.registerProvince = province[0]
        this.form.registerCity = province[1]
        let rObj = {}
        this.nativePlaceOptions.forEach((item) => {
          if (item.value == province[0]) {
            rObj = item.children.find((obj) => obj.value == province[1])
          }
        })
        this.form.nativePlace = `${rObj.province}${rObj.text}`
      } else {
        this.form.registerProvince = ''
        this.form.registerCity = ''
        this.form.nativePlace = ''
      }
    },
    getOrder() {
      this.$http.get('/student/pc/order/myOrders?studentId=' + this.$route.query.studentId)
        .then(orders => {
          this.list = orders.records
        })
    },
    handlePay(orderId, feeType) {
      this.wxQrcode = ''
      this. wxStyle = {
        height: '60px',
        width: '100%',
        display: 'block',
        marginTop: '80px'
      }
      if (orderId) {
        this.$http.get('/student/pc/studyFee/order/getDetail/' + orderId).then(res => {
          this.orderDetail = res
        })
      } else {
        this.$http.post('/student/pc/studyFee/order/create2/' + feeType + '?studentId=' + this.$route.query.studentId).then(res => {
          this.orderDetail = res
        })
      }
      // ALI
      this.dialogVisible = true
    },
    wxpay() {//发起微信支付
      if (this.wxQrcode) {
        return;
      }
      if (!this.timer) {
        this.createTimer();
      }
      this.$http.post('/student/pc/toPay2', { orderId: this.orderDetail.id, payWay: 'WX', studentId: this.$route.query.studentId }).then(res => {
        console.log(res);
        this.wxQrcode = res
        this.wxStyle = {
          height: '100%',
          width: '100%',
          display: 'block'
        };
      })
    },
    createTimer() {
      this.timer = setInterval(() => {
        const params = {
          id: this.orderDetail.id,
          studentId: this.$route.query.studentId
        }
        this.$http.get(`/student/pc/isPaid`, params).then((res) => {
          if (res == 'true') {
            this.cancelTimer()
          }
        });
      }, 3000);
    },
    cancelTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null
      }
      this.dialogVisible = false
      this.getOrder()
    },
    async alipay() {//发起支付宝支付
      if (!this.timer) {
        this.createTimer();
      }

      this.$http.post('/student/pc/toPay2', { orderId: this.orderDetail.id, payWay: 'ALI', studentId: this.$route.query.studentId }).then(res => {
        let aliSubmitDiv = document.getElementById('ali_submit_div');
        aliSubmitDiv.innerHTML = res;
        let formId = 'alipcpayform_' + this.orderDetail.orderNo;
        let formedom = document.getElementById(formId);
        formedom.submit();
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/variable.scss";
.form-item-text {
  width: 100px;
}

.clearfix::after {
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.login {
  .yzm {
    width: 90px;
    height: 50px;
    float: left;
    display: block;
  }

  .login-bannerbox {
    width: 1200px;
    margin: 120px auto;
    background: #fff;
    box-shadow: 0 0 5px 1px hsla(0, 0%, 86.7%, .5);
    border-radius: 5px;
    
    position: relative;
    overflow: hidden;
    padding: 40px 12px 20px 12px;

    .bannerbox-banner {
      border: none;
      vertical-align: top;
    }

    .loginBox {
      box-sizing: border-box;
      padding: 130px 0;
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .baseForm {
        width: 440px;
        background: #FFFFFF;
        box-shadow: 0px 3 10px 0px rgba(205, 205, 205, 0.25);
        border-radius: 10px;
        overflow: hidden;
        margin: 0 auto;
        position: relative;
        z-index: 2;

        .loginBox-title {
          .bgColor {
            background-color: $primary;
          }

          .box {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 22;
            text-align: center;

            p {
              font-weight: bold;
              font-size: 16px;
              color: #FFFFFF;
              margin-bottom: 0;
            }
          }

          .logoImg {
            width: 66px;
            height: 66px;
            border-radius: 50%;
            display: block;
            margin: 0 auto 10px auto;
          }
        }

        .formDiv {
          box-sizing: border-box;
          padding: 40px;

          .loginBox-input {
            width: 360px;
            height: 40px;
            background: #F2F2F2;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 10px 20px;
            border: 0;

            .input-icon {
              width: 14px;
              height: 14px;
              margin: 2px 10px 0 0;
            }

            input {
              flex: 1;
              height: 20px;
              line-height: 20px;
              border: none;
              outline: none;
              background: transparent;
              font-size: 16px;
              color: #333;
            }
          }

          .codeTxt {
            width: 126px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #F2F2F2;
            border-radius: 20px;
            
            margin-left: 4px;
            font-size: 15px;
            color: #333;
            box-sizing: border-box;
            padding: 0 10px;
            margin-bottom: 20px;
          }
        }
      }

      .loginBox-loginbtn {
        background-color: $primary;
        border-radius: 20px;
        width: 100%;
        height: 38px;
        border: none;
        outline: none;
        cursor: pointer;
        color: #ffffff;
        font-size: 14px;
        margin-bottom: 20px;
      }

      .password-retrieve {
        font-size: 13px;
        cursor: pointer;
        line-height: 30px;
        text-align: center;
        color: #005599;
      }

      .functionBox a p {
        color: #999;
        margin: 0 0 0 5px;
      }
    }
  }

  .loging-notice {
    padding: 30px 0 20px 0;

    .notice-mid {
      width: 1200px;
      margin: 0 auto;

      .notice-mid-logo {
        background: url('../assets/home_icon03.png') no-repeat;
        width: 342px;
        height: 86px;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-left: 70px;
        float: left;
        font-size: 24px;
        line-height: 86px;
        color: #ffffff;

        img {
          width: 30px;
          height: 30px;
          vertical-align: text-bottom;
          margin-right: 15px;
        }
      }

      .notice-mid-title {
        border-left: 5px solid #ffa400;
        padding: 15px 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        height: 86px;
        box-sizing: border-box;
        float: left;
        width: 850px;
        margin-left: 8px;
        float: left;
        cursor: pointer;

        .title-text {
          font-size: 16px;
          line-height: 32px;
          color: #333333;
          display: block;
          font-weight: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .title-text:hover {
          color: #1965a2;
        }

        .title-time {
          font-size: 13px;
          color: #666666;
          line-height: 24px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .notice-information {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      margin-top: 15px;

      .information {
        width: 590px;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px rgba(221, 221, 221, 0.6);
        padding: 10px 30px;
        background-color: #ffffff;

        .information-news {
          font-size: 16px;
          color: #333333;
          line-height: 48px;
          margin-bottom: 15px;
          border-bottom: 1px solid #dddddd;

          .news {
            display: inline-block;
            vertical-align: middle;
            margin-bottom: 2px;
            margin-right: 10px;
          }

          .more {
            display: block;
            float: right;
            font-size: 14px;
            color: #999;
          }
        }

        .information-list:nth-child(4),
        .information-list:nth-child(2),
        .information-list:nth-child(3) {
          span {
            background-color: #1965a2;
            color: #ffffff;
          }
        }

        .information-list {
          padding: 5px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .information-serial {
            background-color: #dcdcdc;
            color: #999;
            width: 24px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            font-size: 16px;
            margin-right: 10px;
            display: inline-block;
            border-radius: 50%;
          }

          .information-content {
            color: #333333;
            font-size: 16px;
            line-height: 36px;
            display: inline-block;
            cursor: pointer;
          }

          .information-content:hover {
            color: #1965a2;
          }
        }
      }
    }
  }

  .login-order {
    background-color: #ffffff;
    padding: 40px 0;

    .order-mid {
      width: 1200px;
      margin: 0 auto;

      .order-title {
        background-color: #d7e7f4;
        border-radius: 0px 40px 0px 0px;
        line-height: 56px;
        color: #3a77a8;
        font-size: 24px;
        font-weight: bold;
        padding: 0 50px 0 40px;
        display: inline-block;

        .order-icon {
          display: inline-block;
          width: 22px;
          vertical-align: middle;
          margin-bottom: 2px;
          margin-right: 10px;
        }
      }

      .order-chart {
        padding: 40px 50px;
        background-color: #d7e7f4;

        .lcconTop {
          display: flex;
          justify-content: space-between;

          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-top: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }

        .lcconMiddle {
          height: 9px;
          background-color: #fff;
          margin: 20px 30px;
          position: relative;

          .lcconMiddleCircle1 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: -0.4%;
            top: -4px;
          }

          .lcconMiddleCircle2 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 12%;
            top: -4px;
          }

          .lcconMiddleCircle3 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 24.4%;
            top: -4px;
          }

          .lcconMiddleCircle4 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 36.8%;
            top: -4px;
          }

          .lcconMiddleCircle5 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 49.2%;
            top: -4px;
          }

          .lcconMiddleCircle6 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 61.5%;
            top: -4px;
          }

          .lcconMiddleCircle7 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #3a77a8;
            border-radius: 50%;
            left: 74%;
            top: -4px;
          }

          .lcconMiddleCircle8 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #d9d9d9;
            border-radius: 50%;
            left: 86.3%;
            top: -4px;
          }

          .lcconMiddleCircle9 {
            position: absolute;
            width: 16px;
            height: 16px;
            background-color: #fff;
            border: 3px solid #ffa400;
            border-radius: 50%;
            left: 98.7%;
            top: -4px;
          }

          .lcconMiddleLine {
            border-bottom: 1px dashed #d9d9d9;
            padding-top: 4px;
          }
        }

        .lcconBottom {
          display: flex;
          justify-content: space-between;

          p {
            margin: 0;
            width: 70px;
            height: 40px;
            margin-bottom: 38px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
          }
        }
      }
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

</style>

<style lang="scss" scoped>
@import "@/variable.scss";
.btns {
		display: flex;
		justify-content: flex-end;
		font-size: 13px;

		.my-btn {
			// background: linear-gradient(-90deg, #7275f6, #6eadf8);
			// padding: 6px 10px;
			// border: 6px;
			// color: #fff;
			// border-radius: 6px;
			margin-left: 10px;
		}
	}
.txtOver {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
  .pageTitleBox{
    height: 80px;
    box-sizing: border-box;
    padding: 0 30px;
    .pageTitle{
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }
    .mb0{
      margin-bottom: 0;
    }
  }
  .tabs {
    width: 100%;
    height: 40px;
    background: $primary;
    p {
      width: 80px;
      text-align: center;
      margin: 0 30px;
      font-size: 16px;
      cursor: pointer;
      line-height: 40px;
      position: relative;
      color: rgb(51, 51, 51);
    }

    i {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 20px;
      height: 4px;
      background-color: transparent;
      background: transparent;
    }

    .on {
      color: $primary;
    }

    .bgColor {
      background: $primary;
    }
  }
  .content{
    box-sizing: border-box;
    padding: 0 50px;
    min-height: 450px;
    .li{
      width: 100%;
      border-bottom: 1px solid #F2F2F2;
      box-sizing: border-box;
      padding: 20px 0;
      .topLi{
        margin-bottom: 10px;
        .icon{
          width: 18px;
          height: 18px;
          margin-right: 5px;
          position: relative;
          top: 2px;
        }
        .name{
          font-size: 16px;
          color: #333;
        }
        .score{
          height: 20px;
          line-height: 20px;
          background: #FFA800;
          color: #fff;
          border-radius: 10px;
          margin-left: 10px;
          text-align: center;
          box-sizing: border-box;
          padding: 0 5px;
          font-size: 13px;
        }
        .btns{
          font-size: 16px;
          p{
            margin-left: 20px;
          }
        }
      }
      .descBox{
        font-size: 14px;
        .descLi{
          margin-right: 50px;
        }
      }
    }
  }
  
  .pagination{
    display: flex;
    justify-content: center;
    align-content: center;
  }

.pay-method-box {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-method {
  height: 220px;
  width: 220px;
  display: block;
  border: 1px solid #ccc;
  padding: 0 12px;
  cursor: pointer;
}

</style>
